export default "__VITE_ASSET__479f73cf__"